module.exports = __webpack_public_path__ + "media/images/icons/form-dffec97d02c4d22f273a4f2b291163e3.svg";